// extracted by mini-css-extract-plugin
module.exports = {"info":"InfoDesc_info__3b_V1","icon":"InfoDesc_icon__Z27OG","text":"InfoDesc_text__2b-17"};